import { flushSync } from "react-dom";

/**
 * Apply a layout-changing state update as an animated morph.
 *
 * Uses the View Transitions API: the browser snapshots the page, React
 * commits `update` synchronously, and elements that share a
 * `view-transition-name` before and after (see orbiee.css, "try-on stage")
 * glide between their old and new boxes. Where the API is missing, or the
 * shopper asked for reduced motion, the update simply applies.
 */
export default function morphLayout(update) {
  const reduce =
    typeof window !== "undefined" &&
    window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
  if (typeof document === "undefined" || !document.startViewTransition || reduce) {
    update();
    return;
  }
  try {
    document.startViewTransition(() => {
      flushSync(update);
    });
  } catch (e) {
    // A transition already running can reject a new one; never lose the update.
    update();
  }
}
